import LazyLoad from "react-lazyload";
import { useEffect, useState } from "react";
import { getPrincipalMessage } from "../Service/Api";
import { Link } from "react-router-dom";

function ManagementMarquee() {
  const [message, setMessage] = useState([]);

  useEffect(function () {
    async function getManagementMessage() {
      let management_data = await getPrincipalMessage();
      setMessage(management_data);
    }
    getManagementMessage();
  }, []);

  const emptyArray = [
    {
      name: "Most Rev. Fr. Thomas Kolenchery",
      category: "CHAIRMAN OF JALANDHAR DIOCESE",
      attachments: ["SFSAP/public/Images/chairman.png"],
    },
    {
      name: "MOST REV. JOSE SEBESTIAN T",
      category: "BISHOP OF JALANDHAR DIOCESE",
      attachments: ["SFSAP/public/Images/founder.png"],
    },
  ];

  const data = message.length > 0 ? message : emptyArray;

  return (
    <marquee
      direction="up"
      height="400px"
      onMouseOver={(event) => event.currentTarget.stop()}
      onMouseOut={(event) => event.currentTarget.start()}
    >
      {data
        .sort(function (a, b) {
          return a.category.localeCompare(b.category);
        })
        .map((item, index) => (
          <div className="about-flex" key={item._id || index}>
            <LazyLoad>
              <img
                src={`https://webapi.entab.info/api/image/${item.attachments[0]}`}
                alt="St francis school, Amritsar"
              />
            </LazyLoad>
            <div>
              <p>{item.name}</p>
              <p>
                <span>
                  {item.category === "Chairman"
                    ? "CHAIRMAN OF JALANDHAR DIOCESE"
                    : item.category === "Bishop"
                    ? "BISHOP OF JALANDHAR DIOCESE"
                    : item.category}
                </span>
              </p>
              <Link to={item.category}>Read More</Link>
            </div>
          </div>
        ))}
    </marquee>
  );
}

export default ManagementMarquee;
